const Team = () => import(/* webpackChunkName: "team-group" */ '@/views/team/Team')

export default [
  {
    path: 'team',
    name: 'team',
    components: {
      studyContent: Team
    },
    meta: {
      title: '团队'
    }
  }
]
